module.exports = __webpack_public_path__ + "img/9788993255232.ab0bbdcf.jpg";